import { formatMentionDirective } from "@/lib/mentions/formatMentionDirective";
import type { MentionReference } from "@/lib/mentions/types";

const DEFAULT_CONTEXT_ONLY_MESSAGE = "Please use the selected sources.";

/**
 * Builds launch drain text: context mention directives plus optional user text.
 * Skips document mentions that will be auto-pinned from session uploads.
 */
export function composeLaunchUserMessage(
  text: string,
  contextMentions: MentionReference[] = [],
  uploadedDocumentIds: string[] = [],
): string {
  const trimmed = text.trim();
  const uploaded = new Set(uploadedDocumentIds);
  const seen = new Set<string>();

  const directives: string[] = [];
  for (const mention of contextMentions) {
    const key = `${mention.type}:${mention.id}`;
    if (seen.has(key)) continue;
    if (mention.type === "document" && uploaded.has(mention.id)) continue;
    seen.add(key);
    directives.push(formatMentionDirective(mention));
  }

  if (directives.length === 0) {
    return trimmed;
  }

  const prefix = `${directives.join(" ")} `;
  return trimmed ? `${prefix}${trimmed}` : `${prefix}${DEFAULT_CONTEXT_ONLY_MESSAGE}`.trim();
}

export function defaultLaunchMessageWhenEmpty(
  hasUploads: boolean,
  hasContext: boolean,
): string {
  if (hasUploads) return "Please use the attached documents.";
  if (hasContext) return DEFAULT_CONTEXT_ONLY_MESSAGE;
  return "";
}
